import { useState, useCallback, useEffect } from 'react';

function useForm() {
  const [formData, setFormData] = useState({});
  const [action, setAction] = useState(null);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setFormData(prevData => ({
      ...prevData,
      [name] : value,
    }));
    setAction('onChange');
  }, []);

  const handleFile = useCallback((file) => {
    setFormData(prevData => ({
      ...prevData,
      file,
    }));
    setAction('onFileChange');
  }, []);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    setAction('onSubmit');
  }, []);

  const resetForm = useCallback(() => {
    setFormData({});
    setAction(null);
  }, []);

  useEffect(() => {
    if (action) {
      setAction(null);
    }
  }, [action])

  return {
    formData,
    action,
    handleSubmit,
    handleChange,
    handleFile,
    resetForm,
  };
}

export default useForm;
